import off from './off.svg';
import on from './on.svg';

export default {
  off,
  on,
};
